import { ArrowRight } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import HomeInstantAnalyzer from '../components/HomePage/sections/HomeInstantAnalyzer';
import MarketingPageShell from '../components/marketing/MarketingPageShell';
import { trackCTA } from '../utils/metaPixel';

interface FeatureResumeOptimizerPageProps {
  onNavigate?: (view: string) => void;
}

const FeatureResumeOptimizerPage: React.FC<FeatureResumeOptimizerPageProps> = ({ onNavigate }) => {
  const { t } = useTranslation();

  const handleSignup = () => {
    trackCTA('feature_resume_optimizer_signup');
    onNavigate?.('signup');
  };

  return (
    <MarketingPageShell
      onNavigate={onNavigate}
      activeView="feature-resume-optimizer"
      title={t('pages.resumeOptimizer.seoTitle', 'Free ATS Resume Checker | GoGrabJob')}
      description={t(
        'pages.resumeOptimizer.seoDescription',
        'Upload your resume, paste a job description, and get an instant ATS score — no signup required.',
      )}
      canonical="https://www.gograbjob.com/features/resume-optimizer"
    >
      <div className="marketing-page-hero-band">
        <h1 className="marketing-page-hero-band__title">
          {t('pages.resumeOptimizer.title', 'Resume optimizer & ATS checker')}
        </h1>
        <p className="marketing-page-hero-band__lede">
          {t(
            'pages.resumeOptimizer.lede',
            'See your ATS score before you apply. Paste a job URL or description for a targeted match analysis.',
          )}
        </p>
      </div>
      <HomeInstantAnalyzer onNavigate={onNavigate} variant="section" />
      <div className="marketing-page-cta-band">
        <button type="button" className="home-marketing-cta group" onClick={handleSignup}>
          {t('pages.resumeOptimizer.cta', 'Save my score & unlock full optimization')}
          <ArrowRight className="h-4 w-4 shrink-0" aria-hidden />
        </button>
      </div>
    </MarketingPageShell>
  );
};

export default FeatureResumeOptimizerPage;
